import { axiosClient } from "@/api/axios";

export function get(id) {
  return axiosClient.get(`topic/${id}`);
}
